<ion-skeleton-text *ngIf="!customer" animated class="skeleton"></ion-skeleton-text>


<ion-item [button]="showButton" [routerLink]="routerLink" [queryParams]="queryParams" [detail]="showButton" *ngIf="customer" @fadeInOut>
  <ion-avatar slot="start">
    <app-profile-image [profileImage]="{firstName: customer.firstName}"></app-profile-image>
  </ion-avatar>
  <ion-label>
    <h2>{{ customer.firstName }} {{ customer.lastName }}</h2>
    <p>{{'created.on' | translate}} {{ customer.createdAt | date }}</p>
  </ion-label>
</ion-item>
